import { env } from "./env";

export const webAPIs = {
    //password
    signIn: `${env.REACT_APP_SERVER_URL}user/password`,
    signUp: `${env.REACT_APP_SERVER_URL}user/register`,
    changePassword: `${env.REACT_APP_SERVER_URL}user/changePassword`,
    resetPassword: `${env.REACT_APP_SERVER_URL}user/resetPassword`,
    forgetPassword: `${env.REACT_APP_SERVER_URL}user/forgetPassword`,
    resetPasswordConfirmation: `${env.REACT_APP_SERVER_URL}user/resetPasswordConfirmation`,

    //user
    getUser: `${env.REACT_APP_SERVER_URL}user/getUser`,
    inviteUser: `${env.REACT_APP_SERVER_URL}user/invite`,
    changeUser: `${env.REACT_APP_SERVER_URL}user/changeUser`,
    deleteUser: `${env.REACT_APP_SERVER_URL}user/deleteUser`,
    getUsers: `${env.REACT_APP_SERVER_URL}user/getUsers`,
    getModels: `${env.REACT_APP_SERVER_URL}user/getModels`,
    changeInformation: `${env.REACT_APP_SERVER_URL}user/changeInformation`,
    logout: `${env.REACT_APP_SERVER_URL}user/logout`,

    //conversation
    getConversation: `${env.REACT_APP_SERVER_URL}conversation/getConversation`,
    clearConversation: `${env.REACT_APP_SERVER_URL}conversation/clearConversation`,

    //change Account
    changeSystemPrompt: `${env.REACT_APP_SERVER_URL}conversation/changeSystemPrompt`,
    changeDocument: `${env.REACT_APP_SERVER_URL}conversation/changeDocument`,
    addDocument: `${env.REACT_APP_SERVER_URL}conversation/addDocument`,

    //chat
    chat: `${env.REACT_APP_SERVER_URL}conversation/chat`,

    //create knowledge graph
    knowledgeGraph: `${env.REACT_APP_SERVER_URL}conversation/knowledgeGraph`,

    //select role and system variables
    roleandvariables: `${env.REACT_APP_SERVER_URL}user/roleandvariables`,
    addInsertVarialble: `${env.REACT_APP_SERVER_URL}user/addInsertVariable`,
    editInsertVariable: `${env.REACT_APP_SERVER_URL}user/editInsertVariable`,
    deleteInsertVariable: `${env.REACT_APP_SERVER_URL}user/deleteInsertVariable`,
    getInsertVariables: `${env.REACT_APP_SERVER_URL}user/getInsertVariables`,
    addSystemRole: `${env.REACT_APP_SERVER_URL}user/addSystemRole`,
    editSystemRole: `${env.REACT_APP_SERVER_URL}user/editSystemRole`,
    deleteSystemRole: `${env.REACT_APP_SERVER_URL}user/deleteSystemRole`,
    getSystemRoles: `${env.REACT_APP_SERVER_URL}user/getSystemRoles`,

    getAudioFiles: `${env.REACT_APP_SERVER_URL}conversation/getAudioFiles`,
    getScrapeFiles: `${env.REACT_APP_SERVER_URL}conversation/getScrapeFiles`,
    scrapeURL: `${env.REACT_APP_SERVER_URL}conversation/scrapeURL`,

    //Subscriptions
    getSubscriptions: `${env.REACT_APP_SERVER_URL}user/getSubscriptions`,
    changeSubscription: `${env.REACT_APP_SERVER_URL}user/changeSubscription`,
    createPortalSession: `${env.REACT_APP_SERVER_URL}user/createPortalSession`,

    //PresetPrompts
    getPresetPrompts: `${env.REACT_APP_SERVER_URL}preset-prompts/get-preset-prompts`,
    createPresetPrompt: `${env.REACT_APP_SERVER_URL}preset-prompts`,
    updatePresetPrompt: `${env.REACT_APP_SERVER_URL}preset-prompts`,
    deletePresetPrompt: `${env.REACT_APP_SERVER_URL}preset-prompts`,

    refreshToken: `${env.REACT_APP_SERVER_URL}user/refresh-token`,

    //fetch projects
    createProject: `${env.REACT_APP_SERVER_URL}project`,
    fetchProjects: (accountId) => `${env.REACT_APP_SERVER_URL}project/account/${accountId}`,
    updateProject: (projectId) => `${env.REACT_APP_SERVER_URL}project/${projectId}`,
    deleteProject: (projectId) => `${env.REACT_APP_SERVER_URL}project/${projectId}`,

    // Document Attribute APIs
    createAttribute: `${env.REACT_APP_SERVER_URL}document-attribute/attribute`,
    listAttributes: `${env.REACT_APP_SERVER_URL}document-attribute/attribute`,
    updateAttribute: (id) => `${env.REACT_APP_SERVER_URL}document-attribute/attribute/${id}`,
    deleteAttribute: (id) => `${env.REACT_APP_SERVER_URL}document-attribute/attribute/${id}`,
    createLevel: `${env.REACT_APP_SERVER_URL}document-attribute/level`,
    updateLevel: (id) => `${env.REACT_APP_SERVER_URL}document-attribute/level/${id}`,
    deleteLevel: (id) => `${env.REACT_APP_SERVER_URL}document-attribute/level/${id}`,
    assignAttributeLevel: `${env.REACT_APP_SERVER_URL}document-attribute/assignment`,
    updateAssignment: (id) => `${env.REACT_APP_SERVER_URL}document-attribute/assignment/${id}`,
    deleteAssignment: (id) => `${env.REACT_APP_SERVER_URL}document-attribute/assignment/${id}`,
    filterDocuments: `${env.REACT_APP_SERVER_URL}document-attribute/filter`,
}
